import api from './api';

/**
 * Store interface
 */
export interface Store {
  id: string;
  name: string;
  location?: string;
  address?: string;
  city?: string;
  phone?: string;
  email?: string;
  services?: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Store ride for upcoming rides display
 */
export interface StoreRide {
  id: string;
  name: string;
  departureDate: string;
  departureTime?: string;
  departureLocation: string;
  distanceKm: number;
  maxRiders: number;
  rideType?: string;
  city?: string;
  _count: {
    participants: number;
  };
}

/**
 * Store Service
 * Handles all API calls related to stores for the web platform
 */

/**
 * Get all stores (requires authentication, for discovery)
 * Note: Currently backend requires System Admin, but this service is prepared for when public discovery is enabled
 */
export const getStores = async (params?: {
  search?: string;
  city?: string;
}): Promise<Store[]> => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.city) queryParams.append('city', params.city);
    
    const queryString = queryParams.toString();
    const url = `/stores${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data.stores || [];
  } catch (error: any) {
    // If stores endpoint is not available or requires admin, return empty array
    // This will be updated when public store discovery is enabled
    console.warn('Failed to fetch stores:', error?.response?.status || error);
    return [];
  }
};

/**
 * Get store details by ID
 */
export const getStore = async (id: string): Promise<Store> => {
  const response = await api.get(`/stores/${id}`);
  return response.data.store;
};

/**
 * Get upcoming rides for a store (public, limited to 3)
 */
export const getStoreUpcomingRides = async (storeId: string): Promise<StoreRide[]> => {
  try {
    const response = await api.get(`/stores/${storeId}/upcoming-rides`);
    return response.data.rides || [];
  } catch (error: any) {
    console.warn('Failed to fetch store rides:', error?.response?.status || error);
    return [];
  }
};
